import React, { useState, use, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  Stack,
  Box,
  Typography,
} from "@mui/material";
import { useContext } from "react";
import { ApiContext } from "../Context/Context";
import { Link } from "react-router-dom";

import LoginDialog from "./LoginDialog";

import {
  BaseUrl,
  setLogindata,
  setUserdata,
  LoggedInUserID,
  LoggedInUserName,
} from "../Services/Urls";
import { useNavigate } from "react-router-dom";
import FilterParams from "../Classes/FilterParams";
import ProjectFilterParams from "../Classes/ProjectFilterParams";
import { getSearchData } from "../Services/Helper";
import { useLocation } from "react-router-dom";

function Header({
  displaySearch = true,
  filters = null,
  tabID = null,
  onChange = null,
}) {
  const [openn, setOpenn] = useState(false);

  const {
    logindata,
    setlogindata,
    userData,
    setuserData,
    CityData,
    setCityData,
    vertical,
    setVertical,
    properType,
    setproperType,
    coordinates,
    setcoordinates,
    BHKData,
    setBHKData,
    Locality,
    setLocality,
    Area,
    setArea,
    Projects,
    setProjects,
    searchData,
    setsearchData,
  } = useContext(ApiContext);

  const location = useLocation();

  //console.log(location.pathname);

  const navigate = useNavigate();
  const [openLogin, setOpenLogin] = useState(false);
  const [loginType, setLoginType] = useState(null); // mobile | email
  const [opensearch, setopensearch] = useState(false);
  const [query, setQuery] = useState("");
  const [filteredResults, setFilteredResults] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const [propertyTypeID, setPropertyTypeID] = useState(1);
  const [verticalID, setVerticalID] = useState(1);
  const [tabID_, setTabID_] = useState(384);

  const [PropertyTypeFlag, setPropertyTypeFlag] = useState(1);

  useEffect(() => {
    if (LoggedInUserID == null && LoggedInUserName == null) {
      const storedLoginData = localStorage.getItem("loginData");
      const storedUserData = localStorage.getItem("UserData");
      if (storedLoginData && storedUserData) {
        const parsedData = JSON.parse(storedLoginData);
        const parsedUserData = JSON.parse(storedUserData);
        setlogindata(parsedData);
        setLogindata(parsedData);

        setUserdata(parsedUserData);
        setuserData(parsedUserData);
      }
    }

    if (searchData?.length === 0 && displaySearch === true) {
      getSearchData(
        searchData,
        setsearchData,
        CityData,
        setCityData,
        Locality,
        setLocality,
        Area,
        setArea,
        Projects,
        setProjects,
        coordinates,
      );
    }
  }, []);

  const handleNavigate = () => {
    navigate("/post-property");
    // if (logindata && LoggedInUserID != null) {
    //   navigate("/post-property");
    // } else {
    //   setOpenLogin(true);
    // }
  };

  const navRef = React.useRef(null);
  const navRef2 = React.useRef(null);

  const onAddClick = (e) => {
    navRef.current.classList.add("active");
    navRef2.current.classList.add("active");
  };
  const onRemoveClick = (e) => {
    navRef.current.classList.remove("active");
    navRef2.current.classList.remove("active");
  };
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    setlogindata({});
    setuserData({});

    setLogindata();
    setUserdata();

    localStorage.removeItem("loginData");
    localStorage.removeItem("UserData");
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);

    if (value.trim().length === 0) {
      setFilteredResults([]);
      setopensearch(false);
      return;
    }

    const results = getFilteredSuggestions(
      searchData, // all data
      selectedItems, // selected filters
      value, // search text
      12, // max results
      true, // respect hierarchy
    );

    setFilteredResults(results);
    setopensearch(results.length > 0);
  };

  const getFilteredSuggestions = (
    all,
    selected,
    searchText,
    maxResults = 12,
    respectHierarchy = true,
  ) => {
    const selectedCityIds = new Set(
      selected
        .filter((i) => i.flag === 1)
        .map((i) => i.CityID)
        .filter(Boolean),
    );

    const selectedLocalityIds = new Set(
      selected
        .filter((i) => i.flag === 2)
        .map((i) => i.LocalityID)
        .filter(Boolean),
    );

    const selectedSocietyIds = new Set(
      selected
        .filter((i) => i.flag === 3)
        .map((i) => i.SocietyID)
        .filter(Boolean),
    );

    const selectedAreaIds = new Set(
      selected
        .filter((i) => i.flag === 4)
        .map((i) => i.AreaID)
        .filter(Boolean),
    );

    const matchesName = (item) =>
      item.ResultName?.toLowerCase().includes(searchText.toLowerCase());

    const matchesHierarchy = (item) => {
      if (!respectHierarchy) return true;

      if (
        selectedCityIds.size === 0 &&
        selectedLocalityIds.size === 0 &&
        selectedAreaIds.size === 0 &&
        selectedSocietyIds.size === 0
      ) {
        return true;
      }

      // ----- City constraint -----
      const cityOk =
        selectedCityIds.size > 0
          ? item.CityID != null && selectedCityIds.has(item.CityID)
          : true;

      // ----- Locality constraint -----
      let localityOk = true;
      switch (item.flag) {
        case 2: // Locality
          localityOk = cityOk;
          break;

        case 3: // Society
        case 4: // Area
          if (selectedLocalityIds.size > 0) {
            localityOk =
              item.LocalityID != null &&
              selectedLocalityIds.has(item.LocalityID);
          }
          break;

        default:
          localityOk = true;
      }

      // ----- Area constraint -----
      const areaOk =
        selectedAreaIds.size > 0
          ? item.AreaID != null && selectedAreaIds.has(item.AreaID)
          : true;

      return cityOk && localityOk && areaOk;
    };

    return all
      .filter((item) => {
        const alreadySelected = selected.some(
          (sel) => sel.flag === item.flag && sel.ResultID === item.ResultID,
        );

        if (alreadySelected) return false;

        return matchesHierarchy(item) && matchesName(item);
      })
      .slice(0, maxResults);
  };

  const removeChip = (chipToRemove) => {
    setSelectedItems(
      selectedItems?.filter(
        (chip) => chip?.ResultName !== chipToRemove?.ResultName,
      ),
    );
  };

  const handleType = (type) => {
    if (type === 1) {
      setPropertyTypeID(1);
      setVerticalID(1);
      setTabID_(384);
      setPropertyTypeFlag(1);
    } else if (type === 2) {
      setPropertyTypeID(1);
      setVerticalID(2);
      setTabID_(385);
      setPropertyTypeFlag(2);
    } else if (type === 3) {
      setPropertyTypeID(2);
      setVerticalID(1);
      setTabID_(387);
      setPropertyTypeFlag(3);
    } else if (type === 4) {
      setPropertyTypeID(1);
      setVerticalID(3);
      setTabID_(386);
      setPropertyTypeFlag(4);
    } else if (type === 5) {
      setPropertyTypeFlag(5);
      setOpenn(false);
    }

    // getChoosePropertyType();
  };

  return (
    <>
      <div
        className="off_canvars_overlay"
        ref={navRef2}
        onClick={onRemoveClick}
      ></div>
      <div className="offcanvas_menu">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="offcanvas_menu_wrapper" ref={navRef}>
                <div className="canvas_close">
                  <button onClick={onRemoveClick} className="tgl">
                    <i class="ri-close-line"></i>
                  </button>
                </div>
                <div className="offcanvas-brand text-center mb-40">
                  <img src="assets/img/logo.svg" alt="" />
                </div>
                <div id="menu" className="text-left ">
                  <ul className="navbar-nav ms-auto offcanvas_main_menu">
                    {/* <li className="nav-item">
                  <Link to="/" className="nav-link active">
                    Home
                  </Link>
                </li> */}

                  <li className="nav-item">
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleNavigate();
                        }}
                        className="nav-link"
                      >
                        Post Property
                      </Link>
                    </li>


                    <li className="nav-item">
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          const filters = new FilterParams({
                            propertyType: 1,
                            vertical: 1,
                            featured: null,
                            status: 2,
                          });

                          navigate("/view-all-listing?tabID=384", {
                            state: {
                              filters: filters,
                            },
                          });
                        }}
                        className="nav-link"
                      >
                        Properties
                      </Link>
                    </li>
                    {/* <li className="nav-item">
                  <Link to="#" className="nav-link">
                    Services
                  </Link>
                </li> */}
                    <li className="nav-item">
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          const filters = new ProjectFilterParams({
                            status: 2,
                          });
                          navigate(`/view-all-projects`, {
                            state: {
                              flag: 2,
                              filters: filters,
                            },
                          });
                        }}
                        className="nav-link"
                      >
                        New Projects
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          const filters = new FilterParams({
                            propertyType: 1,
                            vertical: 1,
                            featured: null,
                            status: 2,
                            wishlist: true,
                          });

                          navigate("/view-all-listing?tabID=384", {
                            state: {
                              filters: filters,
                            },
                          });
                        }}
                        className="nav-link"
                      >
                        Wishlist
                      </Link>
                    </li>

                    {logindata && LoggedInUserID != null && (
                      <li className="nav-item">
                        <Link
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();

                            if (logindata && LoggedInUserID != null) {
                              const filters = new FilterParams({
                                propertyType: 1,
                                vertical: 1,
                                featured: null,
                                my: userData?.UserID,
                              });
                              navigate("/view-all-listing?tabID=384", {
                                state: {
                                  filters: filters,
                                },
                              });
                            } else {
                              setOpenLogin(true);
                            }
                          }}
                          className="nav-link"
                        >
                          My Listings
                        </Link>
                      </li>
                    )}

                    {logindata && LoggedInUserID != null && (
                      <li className="nav-item">
                        <Link
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();

                            if (logindata && LoggedInUserID != null) {
                              navigate("/chats");
                            } else {
                              // setOpenLogin(true);
                            }
                          }}
                          className="nav-link"
                        >
                          Chats
                        </Link>
                      </li>
                    )}

                    <li className="nav-item">
                      <Link to="/about-us" className="nav-link">
                        About
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link to="/contactus" className="nav-link">
                        Contact
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <header className="header-wrap">
        <div className="container">
          <nav className="navbar navbar-expand-md navbar-light">
            <Link className="navbar-brand" to="/">
              <img
                className="logo-light"
                src="assets/img/logo.svg"
                alt="logo"
              />
              <img className="logo-dark" src="assets/img/logo.svg" alt="logo" />
            </Link>
            <div
              className="collapse navbar-collapse main-menu-wrap main-menuu"
              id="navbarSupportedContent"
            >
              <div className="menu-close d-lg-none">
                <Link to="">
                  {" "}
                  <i className="ri-close-line" />
                </Link>
              </div>

              <div className="fblock topsearch headertopsearch">
                <div className="form-group">
                  {displaySearch && (
                    <form className="search-form d-flex headersearch">
                      <div className="filter-item-cat">
                        <select
                          onChange={(e) => handleType(Number(e.target.value))}
                          style={{
                            height: 43,
                            padding: "8px 15px 10px 15px",
                            backgroundColor: "#f9fafb",
                            borderRight: "1px solid #d3d3d3",
                            borderRadius: 0,
                            marginRight: 7,
                          }}
                        >
                          <option value={1}>Buy</option>
                          <option value={2}>Rent</option>
                          {/* <option value={3}>Commercial</option> */}
                          {/* <option value={4}>PG</option> */}
                          <option value={5}>New Projects</option>
                        </select>
                      </div>
                      <i className="ri-search-2-line" />
                      <input
                        style={{ borderRadius: 0 }}
                        type="text"
                        value={query}
                        onChange={handleChange}
                        placeholder="Search Properties, Location..."
                      />

                      {opensearch && (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            right: 0,
                            background: "#fff",
                            border: "1px solid #ddd",
                            padding: "10px",
                            zIndex: 10,
                            boxShadow:
                              "0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              gap: "8px",
                              flexWrap: "wrap",
                              marginBottom: 10,
                            }}
                          >
                            {selectedItems?.map((chip, i) => (
                              <div
                                key={i}
                                style={{
                                  padding: "6px 12px",
                                  borderRadius: "16px",
                                  background: "#e0e0e0",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                }}
                              >
                                {chip?.ResultName}
                                <span
                                  onClick={() => removeChip(chip)}
                                  style={{
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                  }}
                                >
                                  ×
                                </span>
                              </div>
                            ))}
                          </div>
                          <ul className="searchlistt">
                            {filteredResults?.length === 0 && (
                              <li>No results found</li>
                            )}
                            {filteredResults?.map((item, index) => (
                              <li
                                key={index}
                                onClick={() => {
                                  // setQuery(item.ResultName);
                                  // setOpen(false);
                                  setSelectedItems((prev) => {
                                    if (
                                      prev.some(
                                        (i) =>
                                          i?.ResultName === item?.ResultName,
                                      )
                                    ) {
                                      return prev;
                                    }
                                    return [...prev, item];
                                  });
                                }}
                              >
                                <span>{item.ResultName}</span>{" "}
                                <span>
                                  {item.flag == 1
                                    ? "City"
                                    : item.flag == 2
                                      ? "Locality"
                                      : item.flag == 3
                                        ? "Project"
                                        : "Area"}
                                </span>
                              </li>
                            ))}
                          </ul>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              gap: "10px",
                              marginTop: "10px",
                            }}
                          >
                            <button
                              onClick={(e) => {
                                e.preventDefault();

                                if (location.pathname == "/view-all-listing") {
                                  onChange((filtersPrev) => ({
                                    ...filtersPrev,
                                    cityIds: selectedItems
                                      .filter((item) => item.flag === 1)
                                      .map((item) => item.CityID),
                                    localityIds: selectedItems
                                      .filter((item) => item.flag === 2)
                                      .map((item) => item.LocalityID),
                                    areaIds: selectedItems
                                      .filter((item) => item.flag === 4)
                                      .map((item) => item.AreaID),
                                    societyIds: selectedItems
                                      .filter((item) => item.flag === 3)
                                      .map((item) => item.SocietyID),

                                    propertyType: propertyTypeID,
                                    vertical: verticalID,
                                    status: 2,
                                  }));
                                } else {
                                  const filters = new FilterParams({
                                    cityIds: selectedItems
                                      .filter((item) => item.flag === 1)
                                      .map((item) => item.CityID),
                                    localityIds: selectedItems
                                      .filter((item) => item.flag === 2)
                                      .map((item) => item.LocalityID),
                                    areaIds: selectedItems
                                      .filter((item) => item.flag === 4)
                                      .map((item) => item.AreaID),
                                    societyIds: selectedItems
                                      .filter((item) => item.flag === 3)
                                      .map((item) => item.SocietyID),

                                    propertyType: propertyTypeID,
                                    vertical: verticalID,
                                    status: 2,
                                  });

                                  navigate(
                                    `/view-all-listing?tabID=${tabID_}`,
                                    {
                                      state: {
                                        filters: filters,
                                      },
                                    },
                                  );
                                }

                                setSelectedItems([]);
                                setopensearch(false);
                              }}
                              style={{
                                background: "green",
                                color: "#fff",
                                border: "none",
                                padding: "6px 14px",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                            >
                              Search
                            </button>

                            <button
                              onClick={() => {
                                setSelectedItems([]);
                                setopensearch(false);
                                // setSelectedItems([]);
                                // setOpensearch(false);
                              }}
                              style={{
                                background: "transparent",
                                color: "green",
                                border: "1px solid green",
                                padding: "6px 14px",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      )}
                    </form>
                  )}
                </div>
              </div>

              {/* <ul className="navbar-nav ms-auto">
              
                <li className="nav-item">
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      const filters = new FilterParams({
                        propertyType: 1,
                        vertical: 1,
                        featured: null,
                          status : 2
                      });

                      navigate("/view-all-listing?tabID=384", {
                        state: {
                          filters: filters,
                        },
                      });
                    }}
                    className="nav-link"
                  >
                    Properties
                  </Link>
                </li>
                
                <li className="nav-item">
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      const filters = new ProjectFilterParams({
                        status : 2
                           
                          });
                          navigate(`/view-all-projects`, {
                            state: {
                              flag: 2,
                              filters: filters,
                            },
                          });
                    }}
                    className="nav-link"
                  >
                    New Projects
                  </Link>
                </li>

                {logindata && LoggedInUserID != null && (
                  <li className="nav-item">
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();

                        if (logindata && LoggedInUserID != null) {
                          const filters = new FilterParams({
                            propertyType: 1,
                            vertical: 1,
                            featured: null,
                            my: userData?.UserID,
                          });
                          navigate("/view-all-listing?tabID=384", {
                            state: {
                              filters: filters,
                            },
                          });
                        } else {
                          setOpenLogin(true);
                        }
                      }}
                      className="nav-link"
                    >
                      My Listings
                    </Link>
                  </li>
                )}


                 {logindata && LoggedInUserID != null && (
                  <li className="nav-item">
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();

                        if (logindata && LoggedInUserID != null) {
                       
                          navigate("/chats");
                        } else {
                         // setOpenLogin(true);
                        }
                      }}
                      className="nav-link"
                    >
                      Chats
                    </Link>
                  </li>
                )}


                <li className="nav-item">
                  <Link to="/about-us" className="nav-link">
                    About
                  </Link>
                </li>
                   <li className="nav-item">
                      <Link to="/contactus" className="nav-link">
                        Contact
                      </Link>
                    </li>
              </ul> */}
              <div className="others-options  md-none">
                <div className="header-btn">
                  <button
                    type="button"
                    className="btn style1"
                    style={{ marginRight: 10 }}
                    onClick={() => {
                      handleNavigate();
                    }}
                  >
                    Post Property
                  </button>

                  {logindata && logindata?.partySr ? (
                    <>
                      <div
                        className="welcome"
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <div
                          className="btn style3"
                          onClick={() => setOpen(!open)}
                        >
                          <strong>{LoggedInUserName}</strong>
                          <i class="ri-arrow-down-s-line"></i>
                        </div>

                        {open && (
                          <ul
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: 0,
                              background: "#fff",
                              border: "1px solid #ccc",
                              listStyle: "none",
                              padding: "8px",
                              margin: 0,
                              width: "150px",
                            }}
                          >
                            <li onClick={() => handleLogout()}>
                              <i class="ri-logout-box-r-line"></i> Logout
                            </li>
                          </ul>
                        )}
                      </div>
                    </>
                  ) : (
                    <button
                      type="button"
                      className="btn style3 loginbtn"
                      onClick={() => setOpenLogin(true)}
                    >
                      {" "}
                      Login{" "}
                    </button>
                  )}

                  <Link
                    style={{ marginLeft: 10 }}
                    onClick={onAddClick}
                    className="menuline"
                  >
                    <i className="ri-menu-line" />
                  </Link>
                </div>
              </div>
            </div>
          </nav>
          <div className="mobile-bar-wrap">
            <div className="mobile-menu d-lg-none">
              <div className="others-options d-flex">
                {displaySearch && (
                  <i
                    class="ri-search-line"
                    onClick={() => setOpenn((prev) => !prev)}
                  ></i>
                )}

                <i
                  onClick={(e) => {
                    e.preventDefault();
                    const filters = new FilterParams({
                      propertyType: 1,
                      vertical: 1,
                      featured: null,
                      status: 2,
                      wishlist: true,
                    });

                    navigate("/view-all-listing?tabID=384", {
                      state: {
                        filters: filters,
                      },
                    });
                  }}
                  class="ri-heart-line"
                ></i>

                <div className="header-btn">
                  {/* <button
                    type="button"
                    className="btn style1"
                    style={{ marginRight: 10 }}
                    onClick={() => {
                      handleNavigate();
                    }}
                  >
                    Post Property
                  </button> */}

                  {logindata && logindata?.partySr ? (
                    <>
                      <div
                        className="welcome"
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <i
                          class="ri-user-line"
                          onClick={() => setOpen(!open)}
                        ></i>
                        {/* <div
                          className="btn style3"
                          onClick={() => setOpen(!open)}
                        >
                          <strong>{LoggedInUserName}</strong>
                          <i class="ri-arrow-down-s-line"></i>
                        </div> */}

                        {open && (
                          <ul
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: 0,
                              background: "#fff",
                              border: "1px solid #ccc",
                              listStyle: "none",
                              padding: "8px",
                              margin: 0,
                              width: "150px",
                            }}
                          >
                            <li onClick={() => handleLogout()}>
                              <i class="ri-logout-box-r-line"></i> Logout
                            </li>
                          </ul>
                        )}
                      </div>
                    </>
                  ) : (
                    <i
                      class="ri-user-line"
                      onClick={() => setOpenLogin(true)}
                    ></i>

                    // <button
                    //   type="button"
                    //   className="btn style3 loginbtn"
                    //   onClick={() => setOpenLogin(true)}
                    // >
                    //   Login
                    // </button>
                  )}
                </div>

                <Link onClick={onAddClick} className="menuline">
                  <i className="ri-menu-line" />
                </Link>
              </div>
            </div>
          </div>
        </div>
        {openn && displaySearch && (
          <form className="search-form d-flex headersearch">
            <div className="filter-item-cat">
              <select
                onChange={(e) => handleType(Number(e.target.value))}
                style={{
                  height: 43,
                  padding: "8px 15px 10px 15px",
                  backgroundColor: "#f9fafb",
                  borderRight: "1px solid #d3d3d3",
                  borderRadius: 0,
                  marginRight: 7,
                }}
              >
                <option value={1}>Buy</option>
                <option value={2}>Rent</option>
                {/* <option value={3}>Commercial</option> */}
                {/* <option value={4}>PG</option> */}
                <option value={5}>New Projects</option>
              </select>
            </div>
            <i className="ri-search-2-line" />
            <input
              style={{ borderRadius: 0 }}
              type="text"
              value={query}
              onChange={handleChange}
              placeholder="Search Properties, Location..."
            />

            {opensearch && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  right: 0,
                  background: "#fff",
                  border: "1px solid #ddd",
                  padding: "10px",
                  zIndex: 10,
                  boxShadow:
                    "0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    flexWrap: "wrap",
                    marginBottom: 10,
                  }}
                >
                  {selectedItems?.map((chip, i) => (
                    <div
                      key={i}
                      style={{
                        padding: "6px 12px",
                        borderRadius: "16px",
                        background: "#e0e0e0",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      {chip?.ResultName}
                      <span
                        onClick={() => removeChip(chip)}
                        style={{
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                      >
                        ×
                      </span>
                    </div>
                  ))}
                </div>
                <ul className="searchlistt">
                  {filteredResults?.length === 0 && <li>No results found</li>}
                  {filteredResults?.map((item, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        // setQuery(item.ResultName);
                        // setOpen(false);
                        setSelectedItems((prev) => {
                          if (
                            prev.some((i) => i?.ResultName === item?.ResultName)
                          ) {
                            return prev;
                          }
                          return [...prev, item];
                        });
                      }}
                    >
                      <span>{item.ResultName}</span>{" "}
                      <span>
                        {item.flag == 1
                          ? "City"
                          : item.flag == 2
                            ? "Locality"
                            : item.flag == 3
                              ? "Project"
                              : "Area"}
                      </span>
                    </li>
                  ))}
                </ul>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  <button
                    onClick={(e) => {
                      e.preventDefault();

                      if (location.pathname == "/view-all-listing") {
                        onChange((filtersPrev) => ({
                          ...filtersPrev,
                          cityIds: selectedItems
                            .filter((item) => item.flag === 1)
                            .map((item) => item.CityID),
                          localityIds: selectedItems
                            .filter((item) => item.flag === 2)
                            .map((item) => item.LocalityID),
                          areaIds: selectedItems
                            .filter((item) => item.flag === 4)
                            .map((item) => item.AreaID),
                          societyIds: selectedItems
                            .filter((item) => item.flag === 3)
                            .map((item) => item.SocietyID),

                          propertyType: propertyTypeID,
                          vertical: verticalID,
                          status: 2,
                        }));
                      } else {
                        const filters = new FilterParams({
                          cityIds: selectedItems
                            .filter((item) => item.flag === 1)
                            .map((item) => item.CityID),
                          localityIds: selectedItems
                            .filter((item) => item.flag === 2)
                            .map((item) => item.LocalityID),
                          areaIds: selectedItems
                            .filter((item) => item.flag === 4)
                            .map((item) => item.AreaID),
                          societyIds: selectedItems
                            .filter((item) => item.flag === 3)
                            .map((item) => item.SocietyID),

                          propertyType: propertyTypeID,
                          vertical: verticalID,
                          status: 2,
                        });

                        navigate(`/view-all-listing?tabID=${tabID_}`, {
                          state: {
                            filters: filters,
                          },
                        });
                      }

                      setSelectedItems([]);
                      setopensearch(false);
                    }}
                    style={{
                      background: "green",
                      color: "#fff",
                      border: "none",
                      padding: "6px 14px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Search
                  </button>

                  <button
                    onClick={() => {
                      setSelectedItems([]);
                      setopensearch(false);
                      // setSelectedItems([]);
                      // setOpensearch(false);
                    }}
                    style={{
                      background: "transparent",
                      color: "green",
                      border: "1px solid green",
                      padding: "6px 14px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </form>
        )}
      </header>

      <LoginDialog
        open={openLogin}
        onClose={() => setOpenLogin(false)}
        onSuccess={(data) => {
          if (data) {
            //  console.log("Login Success:", data);
            setLogindata(data);
            setlogindata(data);

            localStorage.setItem("loginData", JSON.stringify(data));
          }

          //  setUser(data);
        }}
        onUserDetails={(userDetails) => {
          if (userDetails) {
            // console.log("User Details:", userDetails);
            setUserdata(userDetails);
            setuserData(userDetails);
            localStorage.setItem("UserData", JSON.stringify(userDetails));
          }
        }}
      />
    </>
  );
}

export default Header;
